import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { withStyles } from '@material-ui/core';

export const DefaultDatePicker = withStyles({
    root: {
        width: '170px',
        height: '70px',
        border: 'none',
    },

})(KeyboardDatePicker);

export const DefaultDatePickerProvider = withStyles({
    root: {
        border: 'none',
    },
})(MuiPickersUtilsProvider);
